module.exports = __webpack_public_path__ + "assets/img/kv-284fa265.jpg";